var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-progress-linear',{attrs:{"color":"light-blue","height":"10","indeterminate":"","striped":""}}),_c('h3',[_vm._v(_vm._s(_vm.$t("waitingServer")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }